import { injectGlobal } from "styled-components";

injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Montserrat:400,900|Lobster');
`;



// WEBPACK FOOTER //
// ./src/globalStyle.js